<template>
	<div id="usre-baseinfor" class="oh" v-title :data-title="title">
		<leftnav class="fl" mkcode='A' itemcode="A-XHSH"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" >
					<div class="right_boxtitle">
						<span class="fl right_title1 current" style="margin-right: 30px;">协会</span>
						<span class="fl right_title1" @click="routerself('/commerceList')">商会</span>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">协会</span>
							<input type="text" placeholder="请输入协会名称" class="search-input"v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
					</div>
					<div class="opport-screen-list1 qualityenterprise ">
						<dl class="opport-screen bdbe">
							<dt class="fl">所在地</dt>
							<dd class="fl">
								<span :class="areaId == 0?'current a-screen':'a-screen'"		@click="areachoosed(0);">全国地区</span>
								<span v-for="(item,index) in areadata"	@click="areachoosed(item.cityId);"	:class="item.cityId == areaId?'a-screen current' : 'a-screen'">{{item.cityName}}</span>
								<video-teaching :type="1"></video-teaching>
							</dd>
						</dl>
						<dl class="opport-screen bdbe">
							<dt class="fl">产业分类</dt>
							<dd class="fl screenop">
								<span @click="chooseNotion(1,'a',{lable:'全部',value:0,children:[]})" :class="notionCode == 0 ?'a-screen current':'a-screen'">全部</span>
								<span v-for="(item,index) in notionlist"  :class="chooseNotionlist[0] == item.value ?'a-screen current':'a-screen'" @click="chooseNotion(1,'a',item)">{{item.label}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="notionlist1.length>0">
							<dt class="fl titleop">一级产业</dt>
							<dd class="fl">
								<span @click="chooseNotion(2,'all',fenkd)" :class="chooseNotionlist[1]==0 ?'a-screen current':'a-screen'">全部</span>
								<span v-for="(item,index) in notionlist1" :class="chooseNotionlist[1] == item.value ?'a-screen current':'a-screen'" @click="chooseNotion(2,'a',item)">{{item.label}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="notionlist2.length>0">
							<dt class="fl titleop">二级细分</dt>
							<dd class="fl">
								<span @click="chooseNotion(3,'all',fenkd)" :class="chooseNotionlist[2]==0 ?'a-screen current':'a-screen'">全部</span>
								<span v-for="(item,index) in notionlist2" :class="chooseNotionlist[2] == item.value ?'a-screen current':'a-screen'" @click="chooseNotion(3,'a',item)">{{item.label}}</span>
							</dd>
						</dl>
					</div>
				</div>
				
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl"   v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
						<!-- <div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'" 	@click="enlistExport()" v-if="userdata.groupType == 1" v-show="exportnum>0 && enterpristlist.length>0">
							<span>导出数据</span>
							</div> -->
					</div>
					<div class="enterprise_list_box" style="min-height:450px;" >
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>协会名称</th>
								<th>所属产业</th>
								<th>所在地</th>
								<th>企业数</th>
								<th>编辑</th>
							</tr>
							<tr v-for="(list,index) in enterpristlist" :key="index">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<!-- <td v-if="userdata.groupType == 0"><span :class="list.locking?'title onlinetitle td_locktitle locking':'title onlinetitle td_locktitle unlock'" @click="pagelockfun(list.id,list.locking)">{{list.title}}</span><span :class="list.locking?'td_lockimg locking':'td_lockimg unlock'	"></span></td>
								<td v-if="userdata.groupType > 0"><span  class="title onlinetitle" @click="routerlinkid(currentHref,list.id)">{{list.title}}</span></td> -->
								<td><span  class="title onlinetitle" @click="routerlinkid(currentHref,list.id)">{{list.title}}</span></td>
								<td>{{list.notion}}</td>
								<td>{{list.cityText}}</td>
								<td>{{list.enterpriseNum}}</td>
								<td class="collectfont1"><span  @click="listToggleCollect(list,'acoc')">{{list.collectId == 0?'加入':'取消'}}关注</span></td>
							 
							</tr>  
						</table>
					<!-- <div class="w95mg"><freeUserTips :type="1" :bgtype="19" v-if="enterpristlist.length>2" ></freeUserTips></div> -->
					</div> 
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
			<!-- -->
			 
			<!-- 导出列表弹框 -->
			<div class="enlistexportPop" v-show="exportpop">
				<div class="enlistexportPop_box">
					<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
					<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
					<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b class="redfont">{{exportnum}}</b>次</p>
					<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
					<span class="closebtn" @click="exportpop=false"></span>
				</div>
			</div>
			<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
		</div>
	</div>
</template>
<script>
	import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'associationList',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				userdata: {},searchtype:1,
				title: '协会列表',	 
				searchtext: "",areaId:0,fenkd:{children:[]}, 
				areadata:[],
			 notionlist:[],notionlist1:[],notionlist2:[], 
				notiontext: '',notionCode:0,chooseNotionlist:[0,0,0,0,0], 
				kwtextsearch: false,
				kwtextsearchtext: "",
				notionbtn: false,notionbtn1:false,
				enterpristlist:[],
				showscreen: true,
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '',
				permissionsbtn:false,//使用账户查看次数权限弹框开关
				permissionsCount:3,//使用账户查看次数权限弹框次数
				currentHref:'/associationDetail',currentid:0,//点击出现解锁弹框时保存的协会id
				freeUserNum:3,
				isShowFreeUserTips:false,
			}
		},
		components: {
		 freeUserTips
		}, 
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
		},
		mounted() {
				this.getnotionApi();
				this.getareadata();
				this.getassocialist();
		},
		methods: {
			//页面最顶部的解锁判断
			pagelockfun(id,lock){
				// this.currentHref='/associationDetail?id='+id;
				this.currentid=id;
				if(!lock){
					this.routerlinkid(this.currentHref,id); 
				}else{
					if(this.permissionsCount>0){
						this.permissionsbtn=true;
					}else{
						this.bus.$emit('tipspop',{lock:true,type:"permissionNum"});
					};
				} 
				// this.routerself(this.currentHref);
			},
			//确定解锁的判断
			lockPermission(id){
				// console.log(this.currentHref,this.permissionsCount);  
				this.permissionsCount--; 
				this.permissionsbtn=false;
				var cuid=this.currentid;
				this.enterpristlist.forEach(list=>{
					if(list.id == cuid){
						list.locking=false;
					}
				})
				this.routerself(this.currentHref+'?id='+this.currentid);
			},
			//所在地点击
			areachoosed(id){
				this.isShowFreeUserTips = true;
				return;
				this.areaId=id;
				this.getassocialist();
			},
			//获取所在地
			getareadata(){
				var _this=this;
				this.$axios.get(this.$api.free.association.city()).then(function(res) {
					// console.log('获取所在地a',res.data);
					if(res.data.success){
					 _this.areadata=res.data.list; 
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//获取协会列表
			getassocialist(page){
				this.page=page?page:1;
				this.bus.$emit('loading', true);
				var _this=this;
				var cityja=this.splicing('city',this.areaId);
				var notionja=this.splicing('notion',this.notionCode);
				var kwja=this.splicing('kw',this.searchtext);
				// console.log(this.$api.cyl.association.list()+"?page="+this.page+notionja+kwja+cityja)
				var ajaxurl = this.$api.free.association.list();
				this.$axios.get( ajaxurl).then(function(res) {
					console.log('协会列表:',res.data);
					if(res.data.success){
					 _this.enterpristlist=res.data.list; 
						_this.enterpristlist.forEach(list=>{
							list.locking=!list.unlock;
						}) 
						_this.bus.$emit('loading', false);
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.exportnum = res.data.extend.exportRemainder;
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//加入、移除目标企业
			collectToggle(list){
				var _this=this,cid=list.collectId;
				var ajaxurl="",ajaxdata={};
				if(cid == 0){
				 ajaxurl=this.$api.cyl.collect.add();
					ajaxdata={type:list.collectType,id:list.id}
					}else{
						ajaxurl=this.$api.cyl.collect.remove();
						ajaxdata={collectId:list.collectId};
					}
					$.ajax({
						type:"POST",
						url:ajaxurl,
						data:ajaxdata,
						headers:{AuthToken:this.userdata.token },
						success:function(res){ 
							// console.log('1123',res);
							if(res.success){
								if(cid == 0){
									list.collectId=res.data.collectId;
								}else{
									list.collectId=0;
								} 
							} 
						} 
					}) 
			},
			//修改参数设置
			getajaxUrl(apiurl,searchtype) {
				if(searchtype != 'search'){
					this.searchtext="";
				}
				var _this = this, 	ajaxurl = '';  
				var notionja =this.splicing('notion',this.notionCode);
				var kwaja =this.splicing('kw',this.searchtext);
				var areaid =this.splicing('county',this.areaid);
				ajaxurl = apiurl + '?type=' + this.searchtype +notionja+kwaja+areaid;
				return ajaxurl
			},
		//三大产业概念数据
			getnotionApi(){ 
				var _this=this;
				this.$axios.get(this.$api.tag.notion.list() + '?level=5', {
					headers: {	AuthToken: this.userdata.token}
				}).then(function(res) { 
					if (res.data.success) { 
						_this.notionlist = res.data.list.filter(list=>{
							return list.label!='未来产业';
						});    
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//概念单选 层级显示
			chooseNotion(step,type,data){  
				this.isShowFreeUserTips = true;
				return;
					if(type == 'all'){
						this.notionCode=this.chooseNotionlist[step-2];
						this.chooseNotionlist[step-1]=0;
				}else{
					this.chooseNotionlist[step-1]=data.value;
					for(var i=0;i<this.chooseNotionlist.length;i++){
						if(i>step-1){
							this.chooseNotionlist[i]='0';
						}
					}
					this.notionCode=data.value;  
					} 
				if(data.children!=null){
					if(step == 1 ){
						this.notionlist1=data.children.filter(list=>{
							return list.label!='环保';
						}); 
						this.notionlist2=[];this.notionlist3=[]; 
					}else if(step == 2){
						this.notionlist2=data.children; 
					}else if(step == 3){
						// this.notionlist3=data.children;this.notionlist4=[];
					} 
				}
				// console.log(this.notionCode);
				this.getassocialist();
			},
			//企业列表导出数据
			enlistExport() {
				if (this.exportbtn) {
					this.exportpop = true;
				}
				// console.log(this.userdata.groupType,this.exportnum,this.allowexport,this.total);  
				// var ajaxurl=this.$api.cyl.enterprise.export()+'?token='+this.token+'&type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+notionja+tagaja+kwaja+';
			},
			exportlistFun() { //下载报告
				var _this = this;
				var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.export()) + '&token=' + this.userdata.token;
				this.confirmtext = "导出中";
				var iframe = document.getElementById("exportIframe");
				iframe.setAttribute("src", ajaxurl);
				_this.exportnum = this.exportnum--;
				setTimeout(() => {
					_this.confirmtext = "导出成功";
					_this.exportpop = false;
					_this.exportbtn = false;
				}, 5000)
				setTimeout(() => {
					_this.exportbtn = true;
					_this.confirmtext = "确认导出";
					// console.log('一分钟冷却计时')
				}, 60000)
			}, 
			//搜索关键词
			searchkwfun() {
				this.isShowFreeUserTips = true;
				return;
				this.searchtext = $.trim(this.searchtext);
				// if(this.searchtext!="" || ){
				this.getassocialist(1, 'search');
				// } 
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
			pageHandler: function(page) {
				if(page>1){
					this.isShowFreeUserTips = true;
					return;
				}
				// console.log('pageHandler',this.userdata.groupType==0,page > 2)
				this.getassocialist(page);
			},
		 
		}
	}
</script>

<style>

</style>
